export default __webpack_public_path__ + "static/media/react.0d41cf4c.svg";